import { useEffect, useState } from 'react';
import { supabase } from '../config/supabase';
import { useAuthUser } from '../auth/session';
import { isFleetOwnerRole, parseUserRole } from '../auth/roles';
import type { FleetOperator } from '../types/database';

export function useFleetOperator(): {
  operator: FleetOperator | null;
  operatorId: string | null;
  loading: boolean;
} {
  const user = useAuthUser();
  const role = parseUserRole(user);
  const [operator, setOperator] = useState<FleetOperator | null>(null);
  const [loading, setLoading] = useState(isFleetOwnerRole(role));

  useEffect(() => {
    if (!isFleetOwnerRole(role)) {
      setOperator(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    void (async () => {
      const { data, error } = await supabase.from('fleet_operators').select('*').maybeSingle();

      if (cancelled) return;

      if (error) {
        console.error('Failed to load fleet operator:', error.message);
        setOperator(null);
      } else {
        setOperator(data);
      }
      setLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [role, user?.id]);

  return {
    operator,
    operatorId: operator?.id ?? null,
    loading,
  };
}
